(function() {
  // Add a flag to prevent recursive calls
  let isUpdating = false;
  let lastCartData = null;
  
  // Store the original fetch
  const originalFetch = window.fetch;

  // Configuration - you can adjust these values
  const config = {
    domUpdateDelay: 1500, // Wait 500ms for DOM to update before running your code
    maxRetries: 5, // Maximum number of retries if elements aren't found
    retryDelay: 500 // Delay between retries
  };

  // Function to update free shipping with retry mechanism
  function updateFreeShippingWithRetry(retryCount = 0) {
    console.log(`Attempting to update free shipping (attempt ${retryCount + 1}/${config.maxRetries})`);
    
    // Step 1: Get the current price from the progress bar label
    const progressBarLabel = document.getElementById("rebuy-cart__progress-bar-meter-label");

    if (progressBarLabel) {
        const freeShippingLink = document.querySelector("a.wd-announcement-item-freeShip");
        
        if (!freeShippingLink) {
            console.log('Free shipping link not found');
            return;
        }

        // Get the threshold from data attribute
        const threshold = parseFloat(freeShippingLink.getAttribute("data-freeshipthreshold")) || 100;

        // Check the progress bar text content
        const labelText = progressBarLabel.textContent;
        
        // Case 1: Check if unlocked
        if (labelText.includes("Congrats! You've unlocked FREE SHIPPING!")) {
            freeShippingLink.innerHTML = 'Congrats! You\'ve unlocked FREE SHIPPING!*';
            console.log('Free shipping message updated: Unlocked');
            return;
        }
        
        // Extract the remaining amount from the progress bar text
        // Format: "You are $68.00 away from FREE SHIPPING"
        const priceMatch = labelText.match(/\$(\d+\.?\d*)/);
        
        if (priceMatch && priceMatch[1]) {
            const remainingAmount = parseFloat(priceMatch[1]);
            
            if (!isNaN(remainingAmount)) {
                if (remainingAmount === threshold) {
                    // State 1: Cart is empty (remaining amount equals full threshold)
                    freeShippingLink.innerHTML = `FREE SHIPPING on orders over <span>$${threshold.toFixed(2)}</span>*`;
                    console.log('Free shipping message updated: Cart is empty');
                } else {
                    // State 2: Progress - Use the remaining amount directly from progress bar
                    freeShippingLink.innerHTML = `You're only $${remainingAmount.toFixed(2)} away from FREE SHIPPING! Keep shopping*`;
                    console.log('Free shipping message updated: Progress - remaining: $' + remainingAmount.toFixed(2));
                }
            }
        } else {
            console.log('Could not extract price from progress bar text:', labelText);
        }
    } else {
        console.log('Progress bar element not found');
        
        // Retry logic if element not found
        if (retryCount < config.maxRetries - 1) {
            console.log(`Retrying in ${config.retryDelay}ms...`);
            setTimeout(() => {
                updateFreeShippingWithRetry(retryCount + 1);
            }, config.retryDelay);
        } else {
            console.error('Max retries reached. Progress bar element not found.');
        }
    }
}

  // Function to execute when cart changes
  function onCartChange(triggerSource = 'unknown') {
    // Prevent recursive calls
    if (isUpdating) {
      console.log('Already updating, skipping...');
      return;
    }
    
    isUpdating = true;
    console.log('Cart changed! Triggered by:', triggerSource);
    
    // Add delay to ensure DOM has updated
    setTimeout(() => {
      // Run your custom code with retry mechanism
      updateFreeShippingWithRetry();
      
      // Fetch updated cart data with proper error handling
      fetchCartData()
        .then(cart => {
          if (JSON.stringify(cart) !== JSON.stringify(lastCartData)) {
            console.log('Updated cart:', cart);
            lastCartData = cart;
            
            const cartCount = cart.item_count;
            document.querySelectorAll('.cart-count').forEach(el => {
              el.textContent = cartCount;
            });
          }
        })
        .catch(error => console.error('Error fetching cart:', error))
        .finally(() => {
          setTimeout(() => {
            isUpdating = false;
          }, 500);
        });
    }, config.domUpdateDelay); // Wait for DOM to update
  }

  // Helper function to safely fetch cart data
  function fetchCartData() {
    return originalFetch('/cart.js', {
      cache: 'reload',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    });
  }

  // Method 1: Listen to Shopify's AJAX events (if available)
  document.addEventListener('ajaxCart:added', () => onCartChange('ajaxAdd'));
  document.addEventListener('ajaxCart:updated', () => onCartChange('ajaxUpdate'));
  document.addEventListener('ajaxCart:removed', () => onCartChange('ajaxRemove'));

  // Method 2: Listen to cart form submissions
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.action && form.action.includes('/cart')) {
      // Wait for the AJAX to complete
      setTimeout(() => onCartChange('formSubmit'), 1000);
    }
  });

  // Method 3: Listen to cart button clicks
  document.addEventListener('click', function(e) {
    const button = e.target.closest('[name="add"], [data-cart-add], .cart__remove, [data-cart-remove], .rebuy-cart__checkout-button, [data-rebuy-cart-remove]');
    if (button) {
      setTimeout(() => onCartChange('buttonClick'), 1000);
    }
  });

  // Method 4: Polling as fallback
  let lastCartCount = 0;
  
  // Get initial cart count
  fetchCartData()
    .then(cart => {
      lastCartCount = cart.item_count;
      lastCartData = cart;
    })
    .catch(() => {});

  // Check every 3 seconds for cart changes
  setInterval(function() {
    if (isUpdating) return;
    
    fetchCartData()
      .then(cart => {
        if (cart.item_count !== lastCartCount) {
          lastCartCount = cart.item_count;
          lastCartData = cart;
          onCartChange('polling');
        }
      })
      .catch(() => {});
  }, 3000);

  // Expose helper function globally
  window.fetchCartData = fetchCartData;

  // Initial execution with delay
  setTimeout(() => {
    onCartChange('initial');
  }, 2000); // Longer delay for initial load

  // Also listen for Rebuy-specific events (if you're using Rebuy)
  document.addEventListener('rebuy:cart.change', () => {
    setTimeout(() => onCartChange('rebuyEvent'), config.domUpdateDelay);
  });

  document.addEventListener('rebuy:cart.ready', () => {
    setTimeout(() => onCartChange('rebuyReady'), config.domUpdateDelay);
  });

})();












let lastScroll = 0;

window.addEventListener("scroll", function () {

  const currentScroll = window.scrollY;

  // Scroll Down
  if(currentScroll > lastScroll && currentScroll > 200){
    document.body.classList.add("scroll-down");
    document.body.classList.remove("active-scroll");
  }

  // Scroll Up
  if(currentScroll < lastScroll){
    document.body.classList.add("active-scroll");
    document.body.classList.remove("scroll-down");
  }

  // Top of page
  if(currentScroll <= 0){
    document.body.classList.remove("active-scroll");
    document.body.classList.remove("scroll-down");
  }

  lastScroll = currentScroll;
});